enum ApplicationRoles {
  MODERATOR = "Moderator",
}

export default ApplicationRoles;
